import React from 'react';
import { Box, Flex, TextV2 } from '@withjoy/joykit';
import { AiBorderBox } from '@shared/components/AiBorderBox';
import { JoyAiV2 } from '@withjoy/joykit/icons';
import { useTranslation } from '@shared/core';
import { pxToRem } from '@withjoy/joykit/theme';
import type { AutoPopulationPollingStatus } from '@shared/utils/autoPopulation/useAutoPopulation.types';
import { ShimmerAnimation } from '@shared/components/ShimmerAnimation';

interface StayZonesStatusProps
  extends Readonly<{
    status: AutoPopulationPollingStatus;
  }> {}

export const StayZonesStatus: React.FC<StayZonesStatusProps> = ({ status }) => {
  const { tq } = useTranslation('stayZonesAdmin');
  return (
    <Box
      marginTop={6}
      marginX={6}
    >
      <AiBorderBox
        padding={6}
        background="white"
        borderRadius={12}
      >
        <ShimmerAnimation enabled={status === 'PENDING'}>
          <Flex
            gap={3}
            alignItems="center"
          >
            <JoyAiV2 size={48} />
            <TextV2
              typographyVariant={'body1'}
              textAlign="left"
              fontSize={pxToRem(14)}
            >
              {status === 'PENDING'
                ? tq`Finding curated stay zones near your venue...`
                : tq`We found a few curated stay zones suggestions near your venue. Add, remove and tweak them the way you want.`}
            </TextV2>
          </Flex>
        </ShimmerAnimation>
      </AiBorderBox>
    </Box>
  );
};
